<div class="btn-group language-popup" [ngStyle]="{'left.px': x, 'top.px': y}" *ngIf="show">

  <div *ngFor="let language of languages" class="lang-item" (click)="onLanguageSelected(language)">
    <img [src]="language.flagImageUrl" class="icon"><span class="language-name">{{language.name}}</span>
  </div>
</div>